export default () => {
  //-----------------------------------------------------------------------
  // teacher画面のstudent編集でstageのバリデーションエラー時に'div.field_with_errors'で
  // 不具合が起きるのでDOMから除去。
  // 各項目のラベルは赤くならないが許容する（「受講ステータス」は赤くなる）
  const stageRadioButtons = document.querySelectorAll('.stage-radio-button');
  const stageRadioButtonLabels = document.querySelectorAll('.stage-label');

  // inputに'div.field_with_errors'をつけない
  stageRadioButtons.forEach((stageRadioButton) => {
    const parent = stageRadioButton.parentNode

    if (parent.className === 'field_with_errors') {
      parent.parentNode.insertBefore(stageRadioButton, parent);
      parent.remove();
    }
  });

  // labelに'div.field_with_errors'をつけない
  stageRadioButtonLabels.forEach((stageRadioButtonLabel) => {
    const parent = stageRadioButtonLabel.parentNode

    if (parent.className === 'field_with_errors') {
      parent.parentNode.insertBefore(stageRadioButtonLabel, parent);
      parent.remove();
    }
  });
  //-----------------------------------------------------------------------
  // student画面のPWリセット
  const pwResetInputs = document.querySelectorAll('.pw-reset-input');
  pwResetInputs.forEach((input) => {
    const parent = input.parentNode
    if (parent.className === 'field_with_errors') {
      parent.parentNode.insertBefore(input, parent);
      parent.remove();
    }
  })
  //-----------------------------------------------------------------------
  // "app/views/teacher/lesson_time_restrictions/_form.html.erb"
  // "app/views/teacher/general_schools/_form.html.erb"
  const selectLessonsAvailableTimes = document.querySelectorAll('.select_lessons_available_time');
  selectLessonsAvailableTimes.forEach((select) => {
    const parent = select.parentNode
    if (parent.className === 'field_with_errors') {
      parent.parentNode.insertBefore(select, parent);
      parent.remove();
    }
  })
  //-----------------------------------------------------------------------
  // app/views/teacher/lesson_slots/_form.html.erb
  const isMultiLessonCheckBox = document.getElementById('is_multi_lesson');
  if (isMultiLessonCheckBox === null) return;

  const parent = isMultiLessonCheckBox.parentNode
  if (parent.className === 'field_with_errors') {
    parent.parentNode.insertBefore(isMultiLessonCheckBox, parent);
    parent.remove();
  }
}